import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import { SearchInput } from './SearchInput';
import { SelectTag } from './SelectTag';
import { SeparatoreSearch } from './ui/SeparatoreSearch';

export default () => {
    const [sticky, setSticky] = useState();

    useEffect(() => {
        window.addEventListener('scroll', StickSearchBar);

        return () => {
          window.removeEventListener('scroll', StickSearchBar);
        };
    }, []);

    const StickSearchBar = () => {
        var y = window.scrollY;
        setSticky(y >= 500)
    }

    return (
        <div id="search-bar" className={classNames({ 'is-sticky': sticky })}>
            <div className="form-wrap">
                <div className="search-col">
                    <SearchInput />
                </div>

                <SeparatoreSearch className="separator"/>

                <div className="search-nom">
                    <SelectTag />
                </div>

                <div className="submit-col">
                    <button type="submit" className="submit">CERCA</button>
                </div>
            </div>
        </div>
    );
};
